import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import Games from '@/views/Games.vue'
import Systems from '@/views/Systems.vue'
import System from '@/views/System.vue'
import NavBar from '@/components/NavBar.vue'
import RecoveryLink from '@/views/RecoveryLink.vue'
import Admin from '@/views/Admin.vue'
import Splash from '@/views/Splash.vue'

// Deal with NavigationDuplicated issue
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    components: {
      default: Home,
      navigation: NavBar
    }
  },
  {
    path: '/',
    name: 'Splash',
    components: {
      default: Splash,
      navigation: NavBar
    }
  },
  {
    path: '/login',
    name: 'Login',
    components: {
      default: Login,
      navigation: NavBar
    }
  },
  {
    path: '/register',
    components: {
      default: Register,
      navigation: NavBar
    }
  },
  {
    path: '/recovery-link/:linkHash',
    components: {
      default: RecoveryLink,
      navigation: NavBar
    }
  },
  {
    path: '/recovery-link',
    components: {
      default: RecoveryLink,
      navigation: NavBar
    }
  },
  {
    name: 'games',
    path: '/games',
    components: {
      default: Games,
      navigation: NavBar
    }
  },
  {
    name: 'systems',
    path: '/systems',
    components: {
      default: Systems,
      navigation: NavBar
    }
  },
  {
    name: 'system',
    path: '/systems/:id',
    component: System
  },
  {
    name: 'admin',
    path: '/admin',
    components: {
      default: Admin,
      navigation: NavBar
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
